import { AfterViewInit, Component, Injector, Input, OnChanges, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';

@Component({
  selector: 'app-beaconscenario',
  templateUrl: './beaconscenario.component.html',
  styleUrls: ['./beaconscenario.component.css']
})
export class BeaconscenarioComponent extends BaseComponent implements OnInit,OnChanges {
  @Input() scenarioId = 0
  beaconsensors: any = []
  beaconsensor: any = {}
  beacons: any = []
  sensors: any = []
  bsgroups: any = []
  validationObject:any  = {}
  mobiledisplay: any = []
  showInstructions = false
  showModal = false
  
  constructor(injector: Injector) { super(injector) }

  async ngOnInit() {

  }


  async ngOnChanges(){
    if (this.scenarioId == 0) return
    this.loader.show()
    await this.getData()
    this.clearBeaconSensor()
    this.calcMobileDisplay()
    this.loader.hide()
  }

  async getData() {
    this.sensors = await this.db.get("sensor", "getsensors")
    let organization = await this.db.get("scenario", "getOrganization",{scenarioId: this.scenarioId})
    // this.beacons = await this.db.get("beacon", "getbeacons")
    this.beacons = await this.db.get("beacon", "getbeaconsForOrg",{organizationId: organization.id})
    this.beaconsensors = await this.db.get("Scenariobeaconsensor", "GetScenarioBeaconSensorsByScen2", { scenarioid: this.scenarioId })
    this.bsgroups = this.groupBy(this.beaconsensors, "beaconId")
    this.bsgroups.forEach((g: any) => {
      const foundBeacon = this.beacons.find((b: any) => b.id == g.key)
      if (foundBeacon != null){
        g.beacon = foundBeacon
      }else{
        let j=9
      }
      
    })
    let a = 5
  }

  async save() {
    this.validate()
    if (this.validationObject.result == true){
      this.loader.show()
      await this.db.post("scenariobeaconsensor","postscenariobeaconsensor",this.beaconsensor)
      this.clearBeaconSensor()
      await this.getData()
      this.calcMobileDisplay()
      this.showModal = false
      this.loader.hide()
      this.toast.success("Saved record")
    }else{
      
    }
   }

   sensorhaschanged(){
    let sensor = this.sensors.find((x:any)=> x.id == this.beaconsensor.sensorId)
    this.beaconsensor.sensorunits = sensor.units
   }
  validate() {
    this.validationObject.result = true
    this.validationObject.messages = []

    if (this.beaconsensor.beaconId < 1)  this.invalid("Add a valid beacon")

    if (this.beaconsensor.sensorId < 1)  this.invalid("Add a valid sensor")

    if (this.beaconsensor.id == 0) {
      this.beaconsensors.forEach((bs: any) => {
        if (bs.beaconId == this.beaconsensor.beaconId && bs.sensorId == this.beaconsensor.sensorId) {
          this.invalid("Cannot add duplicate beacon sensor record!")
        }
      })
    }

  }
  
  invalid(message:string){
    this.validationObject.result = false;
    this.validationObject.messages.push(message)
  }

  clearBeaconSensor(){
    this.beaconsensor = {
      scenarioId: this.scenarioId,
      id:0,
      beaconId: 0,
      sensorId: 0,
      seqNo: 10,
      minDistance: 1,
      maxDistance: 30,
      maxValue: 30,
      threshold: 40
    }

  }

  calcMobileDisplay(){
    this.mobiledisplay = []
    this.beaconsensors.forEach((bs:any)=>{
      let sensor = this.sensors.find((x:any)=> x.id == bs.sensorId)
      let display = {name: sensor.name,units:sensor.units,seqno: sensor.seqNo}
      let foundAlready = this.mobiledisplay.find((x:any)=>x.name == display.name)
      if (foundAlready == null){
        this.mobiledisplay.push(display)
      }
    });
    this.mobiledisplay =  this.sort(this.mobiledisplay,"seqno")
  }

  edit(bs: any) {
    this.beaconsensor = bs
    this.sensorhaschanged()
    this.showModal = true
  }

  async remove(bs: any) {
    await this.db.delete("scenariobeaconsensor","deletescenariobeaconsensor",{id: bs.id})
    await this.getData()
    this.calcMobileDisplay()
  }

  detailModal(bsconfig: any){
    this.showModal = true
  }
}
